// Imported first so its `@layer base, mantine, mantine-datatable` order
// declaration is registered before Mantine's CSS (pulled in transitively by
// ./app/router) — otherwise `base` would be appended last and outrank Mantine.
import './index.css'
// Self-hosted Poppins (the brand typeface). Self-hosted via @fontsource rather
// than hotlinking Google Fonts: no third-party request (GDPR-clean for the EU
// launch), version-pinned, and `font-display: swap` is built in. Latin subset
// only (Poppins also ships Devanagari — not needed); weights 400/500/600/700.
// Weight 300 is deliberately NOT loaded: the design brief proposed it for
// secondary text, but thin weights hurt legibility at UI sizes, so body and
// secondary text use 400 + dimmed color instead (web best practice wins over
// the brief). @font-face rules aren't affected by cascade layers, so import
// order relative to index.css doesn't matter.
import '@fontsource/poppins/latin-400.css'
import '@fontsource/poppins/latin-500.css'
import '@fontsource/poppins/latin-600.css'
import '@fontsource/poppins/latin-700.css'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { enablePatches } from 'immer'
import { router } from './app/router'
import { configPromise, ConfigContext } from './app/config'

enablePatches()

const queryClient: QueryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 1,
            staleTime: 1000 * 60 * 5, // 5 minutes
        },
    },
})

void configPromise.then((config) => {
    createRoot(document.getElementById('root')!).render(
        <StrictMode>
            <ConfigContext value={config}>
                <QueryClientProvider client={queryClient}>
                    <RouterProvider router={router} />
                </QueryClientProvider>
            </ConfigContext>
        </StrictMode>
    )
})
